import React from 'react'
import PropTypes from 'prop-types'

function Steps(props) {

    const{page, paymentStatus} = props

  return (
    <div className="container text-center">
        <ul className="progressbar ps-0">
            <li className='active'>Select Event</li>
            <li className={page != 'home' ? 'active': null}>Payment</li>
            <li className={page == 'download' && paymentStatus == true ? 'active': null}>Download Ticket</li>
        </ul>
    </div>
  )
}
Steps.propTypes = {
    page: PropTypes.string,
    paymentStatus: PropTypes.bool
}

Steps.defaulProps = {
	page:undefined,
  paymentStatus: false
}
export default Steps
